import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link, Redirect } from 'react-router-dom'
import cx from 'classnames'

import { signup } from '../../api'

import { event as gaEvent, timing as gaTiming, user as gaUser, conversion as gaConversion } from '../../services/ga'

import { Logo, Button } from '../Common'
import Page from './Page'
import Finished from '../Pages/SignupFinished'
import Error from '../Pages/SignupError'
import FacebookUnauthorized from '../Pages/SignupFacebookUnauthorized'
import FacebookNoEmail from '../Pages/SignupFacebookNoEmail'
import FacebookError from '../Pages/SignupFacebookError'
import { Step1, Step2 } from './Steps'

import style from './Signup.scss'

class Signup extends Component {
  static propTypes = {
    search: PropTypes.object,
    data: PropTypes.object,
  }

  state = {
    currentStep: 0,
    step1: {},
    step2: {},
    loading: false,
    finished: false,
    isFromFacebook: false,
  }

  timer = new Date().getTime()

  UNSAFE_componentWillMount() {
    const { search, data } = this.props
    let nextStep
    let step2
    let source

    const isFromFacebook = !!data.facebook

    if (search.fb) {
      if (search.fb === 'nao-autorizado') {
        nextStep = 'facebook_unauthorized'
      } else if (search.fb === 'erro-facebook-code') {
        nextStep = 'facebook_error_facebook'
      } else if (search.fb === 'sem-acesso-email') {
        nextStep = 'facebook_no_email_access'
      }
    }

    if (search.utm_source) {
      source = search.utm_source
    }

    if (isFromFacebook) {
      this.timer = new Date().getTime()
      gaEvent('cadastro', 'facebook', 'Inicio do cadastro')
      nextStep = 2
    }

    if (data.user) {
      step2 = {
        name: data.user.name,
        company: data.user.company,
      }
    }

    if (nextStep || step2 || isFromFacebook) {
      this.setState((state) => ({
        ...state,
        isFromFacebook,
        source,
        currentStep: nextStep || state.currentStep,
        step2: step2 || state.step2,
      }))
    }
  }

  onInitialStep = () => {
    this.timer = new Date().getTime()
    gaEvent('cadastro', 'e-mail', 'Inicio do cadastro')
    this.setState({ ...this.state, currentStep: 1 })
  }

  onPreviousStep = (step) => {
    const previousStep = step || this.state.currentStep - 1
    this.setState((state) => ({
      ...state,
      currentStep: previousStep,
    }))
  }

  onLastStep = (form) => {
    this.setState(
      (state) => ({
        ...state,
        step2: form,
      }),
      () => {
        this.onSignup()
      },
    )
  }

  onNextStep = (form, nextStep) => {
    const currentStep = this.state.currentStep
    this.setState((state) => ({
      ...state,
      currentStep: nextStep,
      [`step${currentStep}`]: form,
    }))
  }

  onSignup = () => {
    if (this.state.loading) return

    const params = {
      source: this.state.source,
      ...this.state.step1, // email e senha
      ...this.state.step2, // demais informações
    }

    this.setState(
      (state) => ({
        ...state,
        loading: true,
      }),
      () => {
        signup(params).then(
          // sucesso
          ({ data }) => {
            const category = this.state.isFromFacebook ? 'facebook' : 'e-mail'

            gaTiming('cadastro', category, new Date().getTime() - this.timer)
            gaEvent('cadastro', category, 'Finalizado cadastro')
            gaUser(data.user.id)
            gaConversion(data.user.name, data.user.email)

            this.setState((state) => ({
              ...state,
              loading: false,
              url: data.url,
              currentStep: 'ok',
            }))
          },
          // erro
          (err) => {
            let nextState

            if (err.response.status === 406) {
              nextState = {
                loading: false,
                error: err.response.data.message,
              }
            } else {
              nextState = {
                loading: false,
                currentStep: 'error',
              }
            }

            this.setState((state) => ({
              ...state,
              ...nextState,
            }))
          },
        )
      },
    )
  }

  render() {
    const mobile = this.props.data.mobile
    const recaptchakey = this.props.data.recaptchakey
    const { currentStep, step1, step2, loading, error, url, isFromFacebook } = this.state

    let content
    let button = null

    switch (currentStep) {
      case 1:
        button = (
          <Link id="link-login" to="/login" className={style.link}>
            <Button theme="white" className={style.button} xl>
              login
            </Button>
          </Link>
        )
        content = <Step1 isFromFacebook={isFromFacebook} mobile={mobile} recaptchakey={recaptchakey} form={step1} onNextStep={this.onNextStep} />
        break

      case 2:
        button = !isFromFacebook && (
          <Button onClick={this.onPreviousStep} theme="white" className={cx(style.link, style.button)} xl>
            voltar
          </Button>
        )
        content = (
          <Step2
            isFromFacebook={isFromFacebook}
            form={step2}
            onPreviousStep={this.onPreviousStep}
            onNextStep={this.onLastStep}
          />
        )
        break

      case 'ok':
        return (
          <Redirect
            to={{
              pathname: '/thanks',
              search: `?mobile=${mobile}&url=${url}`,
            }}
          />
        )

      case 'error':
        content = <Error loading={loading} onRetry={this.onSignup} />
        break

      case 'facebook_unauthorized':
        content = <FacebookUnauthorized />
        button = (
          <Link to="/login" className={style.link}>
            <Button theme="white" className={style.button} xl>
              cancelar
            </Button>
          </Link>
        )
        break

      case 'facebook_no_email_access':
        content = <FacebookNoEmail onInitialStep={this.onInitialStep} />
        break

      case 'facebook_error_facebook':
        content = <FacebookError onInitialStep={this.onInitialStep} />
        button = (
          <Button onClick={() => this.onPreviousStep(0)} theme="white" className={cx(style.link, style.button)} xl>
            recomeçar
          </Button>
        )
        break

      default:
        content = <Page mobile={mobile} onInitialStep={this.onInitialStep} />
        button = !mobile && (
          <Link id="link-login" to="/login" className={style.link}>
            <Button theme="white" className={style.button} xl>
              login
            </Button>
          </Link>
        )
    }
    return (
      <div className={style.wrapper}>
        <div className={style.header}>
          <Logo className={style.logo} />
          {button}
        </div>
        {content}
      </div>
    )
  }
}

export default Signup



// WEBPACK FOOTER //
// ./src/components/Signup/Signup.js